export default __webpack_public_path__ + "static/media/Access-to-AI-Technologies.d949868e.png";